/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Devices_UnavailableInputs */

const vi_irrigation_devices_unavailable = /** @type {(inputs: Irrigation_Devices_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không đọc được`)
};

/**

* @param {Irrigation_Devices_UnavailableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_devices_unavailable = /** @type {((inputs?: Irrigation_Devices_UnavailableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Devices_UnavailableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_devices_unavailable(inputs)
});